<template>
  <ValidationObserver ref="customerForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
      <v-form rel="customerForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <CustomerAutocomplete
                  v-if="!customer"
                  v-model="value.customerId"
                  :items="customers"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.postalCode"
                  rules="required"
                  label="PSČ"
                  outlined
                  dense
                  type="number"
                  background-color="white"
                  :loading="distributorLoading"
                  @input="(event) => loadDistributor(event)"
                />
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="distributor.name"
                  label="Distributor"
                  rules="required"
                  dense
                  outlined
                  readonly
                  disabled
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="py-0 px-6">
                <v-switch v-model="areaFlat" inset dense @change="handleAreaValue">
                  <template slot="label">
                    <div style="color: #21262a">
                      {{ areaFlat ? 'Byt' : 'Dům' }}
                    </div>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="areaFlat" cols="12" sm="12" class="py-0 px-5">
                <v-radio-group v-model="value.gasOrder.areaId" mandatory row>
                  <v-radio
                    v-for="item in areaFlats"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
              <v-col v-if="!areaFlat" cols="12" sm="12" class="py-0 px-5">
                <v-radio-group v-model="value.gasOrder.areaId" mandatory row>
                  <v-radio
                    v-for="item in areaHouses"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <v-radio-group v-model="value.gasOrder.usageIds" mandatory multiple row>
                  <v-radio
                    v-for="item in usages"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :checked="item.active"
                    @click="uncheckUsage(item)"
                  />
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <v-radio-group v-model="value.gasOrder.personId" mandatory row>
                  <v-radio
                    v-for="item in persons"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="mt-10">
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.gasOrder.consumption"
                  rules="required"
                  type="number"
                  outlined
                  dense
                  label="Spotřeba"
                  data-cy="surname"
                  suffix="kWh"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.currentSupplierId"
                  label="Současný dodavatel"
                  outlined
                  dense
                  background-color="white"
                  :items="currentSuppliers"
                  item-text="name"
                  item-value="id"
                  :loading="suppliersLoading"
                  :disabled="disabledWh"
                  @change="(event) => loadCurrentSupplierProduct(event)"
                />
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.currentSupplierProductId"
                  label="Současný produkt"
                  outlined
                  dense
                  background-color="white"
                  :items="currentSupplierProducts"
                  item-text="name"
                  item-value="id"
                  :disabled="disabledWh"
                  :loading="currentSuppliersProductLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.supplierId"
                  label="Nový dodavatel"
                  outlined
                  dense
                  background-color="white"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  :loading="suppliersLoading"
                  :disabled="disabledWh"
                  @change="(event) => loadSupplierProduct(event)"
                />
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.supplierProductId"
                  label="Nový produkt"
                  outlined
                  dense
                  background-color="white"
                  :items="supplierProducts"
                  item-text="name"
                  item-value="id"
                  :disabled="disabledWh"
                  :loading="suppliersProductLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.eic"
                  label="EIC"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.gasOrder.connectionBegin"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Datum připojení"
                  data-cy="phone"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.customerType"
                  label="Typ zákazníka"
                  outlined
                  dense
                  background-color="white"
                  :items="customerTypes"
                  item-text="text"
                  item-value="name"
                  :loading="customerTypesLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.contractType"
                  label="Typ smlouvy"
                  outlined
                  dense
                  background-color="white"
                  :items="contractTypes"
                  item-text="text"
                  item-value="name"
                  :loading="contractTypeLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.renewalPeriodType"
                  label="Prolongace"
                  outlined
                  dense
                  rules="required"
                  background-color="white"
                  :items="renewalPeriodTypes"
                  item-text="text"
                  item-value="name"
                  :loading="renewalPeriodTypeLoading"
                  :clearable="true"
                />
              </v-col>
              <v-col
                v-if="value.gasOrder.renewalPeriodType === 'CERTAIN'"
                cols="12"
                sm="4"
                class="py-0 px-5"
              >
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.renewalPeriod"
                  label="Doba"
                  outlined
                  dense
                  :rules="value.gasOrder.renewalPeriodType === 'CERTAIN' ? 'required' : ''"
                  :disabled="value.gasOrder.renewalPeriodType !== 'CERTAIN'"
                  background-color="white"
                  type="number"
                />
              </v-col>
              <v-col
                v-if="value.gasOrder.renewalPeriodType === 'CERTAIN'"
                cols="12"
                sm="4"
                class="py-0 px-5"
              >
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.renewalPeriodUnit"
                  label="Jednotka"
                  outlined
                  dense
                  :rules="value.gasOrder.renewalPeriodType === 'CERTAIN' ? 'required' : ''"
                  :disabled="value.gasOrder.renewalPeriodType !== 'CERTAIN'"
                  background-color="white"
                  :items="renewalPeriodUnits"
                  item-text="text"
                  item-value="name"
                  :loading="renewalPeriodUnitLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.gasOrder.contractSigned"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Datum podpisu smlouvy"
                  data-cy="phone"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.gasOrder.contractEnd"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Datum ukončení smlouvy"
                  data-cy="phone"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.contractBonus"
                  label="Podpisová prémie"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.contractConcludingType"
                  label="Způsob podpisu smlouvy"
                  outlined
                  dense
                  background-color="white"
                  :items="contractConcludingTypes"
                  item-text="text"
                  item-value="name"
                  :loading="contractConcludingTypeLoading"
                  :clearable="true"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.contractTerminationType"
                  label="Způsob ukončení smlouvy"
                  outlined
                  dense
                  background-color="white"
                  :items="contractTerminationTypes"
                  item-text="text"
                  item-value="name"
                  :loading="contractTerminationTypeLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.terminationPeriod"
                  label="Výpovědní lhůta"
                  outlined
                  dense
                  background-color="white"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.terminationPeriodType"
                  label="Výpovědní lhůta"
                  outlined
                  dense
                  background-color="white"
                  :items="terminationPeriodTypes"
                  item-text="text"
                  item-value="name"
                  :loading="terminationPeriodTypeLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.refund"
                  label="Refundace"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.advanceAmount"
                  label="Výše zálohy Kč"
                  outlined
                  dense
                  background-color="white"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.advancePeriod"
                  label="Platba záloh"
                  outlined
                  dense
                  background-color="white"
                  :items="advancePeriods"
                  item-text="text"
                  item-value="name"
                  :loading="advancePeriodLoading"
                  :clearable="true"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.advanceType"
                  label="Způsob platby zálohy"
                  outlined
                  dense
                  background-color="white"
                  :items="advanceTypes"
                  item-text="text"
                  item-value="name"
                  :loading="advanceTypeLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.bankAccountNumber"
                  label="Číslo bankovního účtu"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.bankCode"
                  label="Kód banky"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.sipoNumber"
                  label="Číslo SIPO"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.supplierChangeType"
                  label="Typ změny dodavatele"
                  outlined
                  dense
                  background-color="white"
                  :items="supplierChangeTypes"
                  item-text="text"
                  item-value="name"
                  :loading="supplierChangeTypeLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.gasOrder.dataSentenceSupplierId"
                  label="Dodavatel - číselník Yello"
                  outlined
                  dense
                  background-color="white"
                  :items="dataSentenceSuppliers"
                  item-text="name"
                  item-value="id"
                  :loading="dataSentenceSupplierLoading"
                  :clearable="true"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.dataSentenceProduct"
                  label="Produkt - číselník Yello"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.invoicePdf"
                  label="Faktura (PDF)"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.gasOrder.invoicePdfEmail"
                  label="Faktura (PDF) - email"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.serviceProvideImmediately"
                  label="Poskytování služby - okamžitě"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.gdpr"
                  label="GDPR"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.marketing"
                  label="MKT"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-card-title class="px-0 pb-12 pt-7">
              Čestné prohlášení
              <v-spacer></v-spacer>
            </v-card-title>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerEditableWithValidation
                  v-model="value.gasOrder.affidavitCustomerDate"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Dne"
                  data-cy="phone"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.affidavitCustomerDied"
                  label="Zemřel"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <YesNoAutocomplete
                  v-model="value.gasOrder.affidavitCustomerLeft"
                  label="Trvale opustil odběrné místo"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'
import CustomerAutocomplete from '@/components/forms/inputs/CustomerAutocomplete'
import YesNoAutocomplete from '../YesNoAutocomplete.vue'
import VDatePickerEditableWithValidation from '../validators/VDatePickerEditableWithValidation.vue'

export default {
  name: 'OrderGasForm',
  components: {
    VDatePickerEditableWithValidation,
    YesNoAutocomplete,
    CustomerAutocomplete,
    VAutocompleteWithValidation,
  },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    saving: {
      type: Boolean,
      default: false,
      required: false,
    },
    customer: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      customers: [],
      areaFlats: [
        {
          id: 1,
          name: 'Do 50m2',
        },
        {
          id: 2,
          name: 'Do 80m2',
        },
        {
          id: 3,
          name: 'Nad 80m2',
        },
      ],
      areaHouses: [
        {
          id: 4,
          name: 'Do 90m2',
        },
        {
          id: 5,
          name: 'Do 150m2',
        },
        {
          id: 6,
          name: 'Nad 150m2',
        },
      ],
      areaId: 1,
      areaFlat: true,
      persons: [
        {
          id: 1,
          name: '1-2 osoby',
        },
        {
          id: 2,
          name: '3-4 osoby',
        },
        {
          id: 3,
          name: '5 a více osob',
        },
      ],
      usages: [
        {
          id: 2,
          name: 'Vaření',
        },
        {
          id: 3,
          name: 'Ohřev vody',
        },
        {
          id: 4,
          name: 'Topení',
        },
      ],
      distributors: [
        {
          id: 1,
          name: 'pre',
        },
        {
          id: 2,
          name: 'pre',
        },
        {
          id: 3,
          name: 'pre',
        },
      ],
      distributor: {
        name: null,
      },
      postalCode: null,
      distributorId: null,
      suppliers: [],
      supplierProducts: [],
      currentSuppliers: [],
      currentSupplierProducts: [],
      advancePeriods: [],
      advanceTypes: [],
      terminationPeriodTypes: [],
      renewalPeriodTypes: [],
      renewalPeriodUnits: [],
      customerTypes: [],
      contractTypes: [],
      contractConcludingTypes: [],
      contractTerminationTypes: [],
      supplierChangeTypes: [],
      dataSentenceSuppliers: [],
      distributorLoading: false,
      suppliersLoading: false,
      suppliersProductLoading: false,
      currentSuppliersProductLoading: false,
      advancePeriodLoading: false,
      advanceTypeLoading: false,
      terminationPeriodTypeLoading: false,
      renewalPeriodTypeLoading: false,
      renewalPeriodUnitLoading: false,
      customerTypesLoading: false,
      contractTypeLoading: false,
      contractConcludingTypeLoading: false,
      contractTerminationTypeLoading: false,
      supplierChangeTypeLoading: false,
      dataSentenceSupplierLoading: false,
    }
  },
  computed: {
    disabledWh() {
      return this.distributorId == null
    },
  },
  created() {
    this.loadSuppliers()
    this.loadAdvancePeriods()
    this.loadAdvanceTypes()
    this.loadTerminationPeriodTypes()
    this.checkAreaFlat()
    this.loadRenewalPeriodTypes()
    this.loadRenewalPeriodUnit()
    this.loadCustomerTypes()
    this.loadContractType()
    this.loadContractConcludingType()
    this.loadContractTerminationType()
    this.loadSupplierChangeType()
    this.loadDataSentenceSupplier()
  },
  methods: {
    ...mapActions({
      createOrder: 'gas/createOrder',
      getDistributor: 'gas/getDistributor',
      getSuppliers: 'gas/getSuppliers',
      getSupplierProducts: 'gas/getSupplierProducts',
      getAdvancePeriods: 'enum/listAdvancePeriods',
      getAdvanceTypes: 'enum/listAdvanceTypes',
      getTerminationPeriodTypes: 'enum/listTerminationPeriodTypes',
      getRenewalPeriodTypes: 'enum/listRenewalPeriodTypes',
      getRenewalPeriodUnit: 'enum/listRenewalPeriodUnit',
      getContractType: 'enum/listContractType',
      getContractConcludingType: 'enum/listContractConcludingType',
      getContractTerminationType: 'enum/listContractTerminationType',
      getSupplierChangeType: 'enum/listSupplierChangeType',
      getDataSentenceSupplier: 'enum/listDataSentenceSupplier',
      listOrderCustomerType: 'enum/listOrderCustomerType',
    }),
    loadDistributor(postalCode) {
      this.distributorId = null
      this.value.gasOrder.distributorId = null
      this.distributor = { name: null }
      if (postalCode.toString().length !== 5) {
        return
      }
      this.distributorLoading = true
      this.getDistributor(postalCode)
        .then((response) => {
          this.distributor = response.data
          this.distributorId = response.data.id
          this.value.gasOrder.distributorId = response.data.id
        })
        .finally(() => {
          this.distributorLoading = false
        })
        .catch(() => {})
    },
    loadSuppliers() {
      this.suppliersLoading = true
      this.getSuppliers()
        .then((response) => {
          this.suppliers = response.data
          this.currentSuppliers = response.data
        })
        .finally(() => {
          this.suppliersLoading = false
        })
    },
    loadSupplierProduct() {
      if (this.value.gasOrder.supplierId == null) {
        return
      }
      this.suppliersProductLoading = true
      this.getSupplierProducts({
        id: this.value.gasOrder.supplierId,
        distributorId: this.value.gasOrder.distributorId,
      })
        .then((response) => {
          this.supplierProducts = response.data
        })
        .finally(() => {
          this.suppliersProductLoading = false
        })
    },
    loadCurrentSupplierProduct() {
      if (this.value.gasOrder.currentSupplierId == null) {
        return
      }
      this.currentSuppliersProductLoading = true
      this.getSupplierProducts({
        id: this.value.gasOrder.currentSupplierId,
        distributorId: this.value.gasOrder.distributorId,
      })
        .then((response) => {
          this.currentSupplierProducts = response.data
        })
        .finally(() => {
          this.currentSuppliersProductLoading = false
        })
    },
    loadAdvancePeriods() {
      this.advancePeriodLoading = true
      this.getAdvancePeriods()
        .then((response) => {
          this.advancePeriods = response.data
        })
        .finally(() => {
          this.advancePeriodLoading = false
        })
    },
    loadAdvanceTypes() {
      this.advanceTypeLoading = true
      this.getAdvanceTypes()
        .then((response) => {
          this.advanceTypes = response.data
        })
        .finally(() => {
          this.advanceTypeLoading = false
        })
    },
    loadTerminationPeriodTypes() {
      this.terminationPeriodTypeLoading = true
      this.getTerminationPeriodTypes()
        .then((response) => {
          this.terminationPeriodTypes = response.data
        })
        .finally(() => {
          this.terminationPeriodTypeLoading = false
        })
    },
    loadRenewalPeriodTypes() {
      this.renewalPeriodTypeLoading = true
      this.getRenewalPeriodTypes()
        .then((response) => {
          this.renewalPeriodTypes = response.data
        })
        .finally(() => {
          this.renewalPeriodTypeLoading = false
        })
    },
    loadRenewalPeriodUnit() {
      this.renewalPeriodUnitLoading = true
      this.getRenewalPeriodUnit()
        .then((response) => {
          this.renewalPeriodUnits = response.data
        })
        .finally(() => {
          this.renewalPeriodUnitLoading = false
        })
    },
    loadCustomerTypes() {
      this.customerTypesLoading = true
      this.listOrderCustomerType()
        .then((response) => {
          this.customerTypes = response.data
        })
        .finally(() => {
          this.customerTypesLoading = false
        })
    },
    loadContractType() {
      this.contractTypeLoading = true
      this.getContractType()
        .then((response) => {
          this.contractTypes = response.data
        })
        .finally(() => {
          this.contractTypeLoading = false
        })
    },
    loadContractConcludingType() {
      this.contractConcludingTypeLoading = true
      this.getContractConcludingType()
        .then((response) => {
          this.contractConcludingTypes = response.data
        })
        .finally(() => {
          this.contractConcludingTypeLoading = false
        })
    },
    loadContractTerminationType() {
      this.contractTerminationTypeLoading = true
      this.getContractTerminationType()
        .then((response) => {
          this.contractTerminationTypes = response.data
        })
        .finally(() => {
          this.contractTerminationTypeLoading = false
        })
    },
    loadSupplierChangeType() {
      this.supplierChangeTypeLoading = true
      this.getSupplierChangeType()
        .then((response) => {
          this.supplierChangeTypes = response.data
        })
        .finally(() => {
          this.supplierChangeTypeLoading = false
        })
    },
    loadDataSentenceSupplier() {
      this.dataSentenceSupplierLoading = true
      this.getDataSentenceSupplier()
        .then((response) => {
          this.dataSentenceSuppliers = response.data
        })
        .finally(() => {
          this.dataSentenceSupplierLoading = false
        })
    },
    checkAreaFlat() {
      if (this.value.gasOrder.areaId) {
        this.areaFlat =
          this.areaFlats.filter((area) => area.id === this.value.gasOrder.areaId).length > 0
        return
      }
      this.areaFlat = true
    },
    handleAreaValue() {
      if (this.areaFlat) {
        this.value.gasOrder.areaId = this.areaFlats[0].id
      } else {
        this.value.gasOrder.areaId = this.areaHouses[0].id
      }
    },
    uncheckUsage(item) {
      item.active = !item.active
      this.value.gasOrder.usageIds = this.value.gasOrder.usageIds.filter(
        (value, index) => this.value.gasOrder.usageIds.indexOf(value) === index
      )
      if (!item.active) {
        const removeIndex = this.value.gasOrder.usageIds
          .map(function (id) {
            return id
          })
          .indexOf(item.id)

        this.value.gasOrder.usageIds.splice(removeIndex, 1)
      }
    },
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
